<template>
  <div id="DepartmentManage" class="well" style="padding: 0 1em">
    <b-tabs content-class="mt-3" justified>
      <b-tab :active="dataMode == 0" :disabled="dataMode != 0">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請學年度：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>
                <th style="min-width: 6em"></th>
                <th style="min-width: 5em"></th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetSportsODS2/'
                        .concat(queryInfo.STime)"
                    v-show="total > 0"
                  >

                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.Excel_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            v-if="docRecordList != null"
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 10em">競賽種類名稱\系所</th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[0] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[1] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[2] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[3] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[4] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[5] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[6] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[7] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[8] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[9] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[10] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[11] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[12] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[13] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[14] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[15] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[16] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[17] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[18] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[19] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[20] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[21] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[22] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[23] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[24] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[25] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[26] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[27] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[28] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[29] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[30] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[31] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[32] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[33] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[34] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[35] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[36] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[37] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[38] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[39] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[40] }}
                </th>
                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[41] }}
                </th>

                <th style="min-width: 3.5em">
                  {{ docRecordList[0].title[42] }}
                </th>
              </tr>
            </thead>
            <tbody v-if="docRecordList != null" class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in TypeNameList"
                :key="item.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: left">
                  {{ item.typeName }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[0] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[1] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[2] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[3] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[4] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[5] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[6] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[7] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[8] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[9] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[10] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[11] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[12] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[13] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[14] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[15] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[16] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[17] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[18] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[19] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[20] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[21] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[22] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[23] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[24] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[25] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[26] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[27] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[28] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[29] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[30] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[31] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[32] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[33] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[34] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[35] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[36] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[37] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[38] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[39] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[40] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[41] }}
                </td>
                <td style="text-align: left">
                  {{ docRecordList[index].amount[42] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "DepartmentManage",
  data() {
    return {
      TypeNameList: null,
      total: 0,
      dataMode: 0,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 0,
      },
      docRecordList: null,
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    filteredDocs: function () {
      let data = [];
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    checkSaveData() {
      let msg = "";
      if (this.queryInfo.STime == null) msg = "請輸入申請年度";

      return msg;
    },
    query() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetDepTypeNameList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;

              vm.total = vm.docRecordList.length;
              vm.getAllTypeName();
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    getAllTypeName() {
      let vm = this;
      this.$http
        .get("./WebApi/EconomicDisadvantage/GetAllTypeName/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.TypeNameList = response.data;

            // vm.total = vm.inputData.length;
            // vm.currentPage = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    // getAllmini_name_data2() {
    //   let vm = this;
    //   this.$http
    //     .get("./WebApi/EconomicDisadvantage/GetAllmini_name_data2/")
    //     .then((response) => {
    //       if (!tools.isNull(response)) {
    //         vm.docRecordList = response.data;

    //         // vm.total = vm.inputData.length;
    //         // vm.currentPage = 1;
    //       }
    //     })
    //     .catch(function (error) {
    //       alert("網路連線失敗" + error);
    //       // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
    //     });
    // },
  },
  created() {
    console.log("======created DepartmentManageView =====");
  //  this.getAllTypeName();
  },
  mounted() {
    console.log("======mounted DepartmentManageView =====");

 //   this.getAllmini_name_data2();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
